import { Component, OnInit } from '@angular/core';
import { Global } from '../../../app.global';
import { flashAnimation } from '../../../app.animations';
import { GlobalObservables } from '../../../app.global.observer';

// Services
import { AdminService } from '../../services/admin.service';
import { SettingsService } from '../../../authentication/services/settings.service';
import { HelperService } from '../../../shared/common/services/helper.service';

import * as _moment from 'moment';

import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';

import { AppDateAdapter, APP_DATE_FORMATS } from '../../../shared/common/date.adapter';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'playground',
  templateUrl: './playground.component.html',
  styleUrls: ['./playground.component.scss'],
  animations: [flashAnimation],
  providers: [
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: APP_DATE_FORMATS,
    },
  ],
})
export class PlaygroundComponent implements OnInit {
  appSettingInfo = [];
  textResourceKey = '';
  textResourceValue = '';

  startDate;

  constructor(
    private adminService: AdminService,
    public global: Global,
    private globalObs: GlobalObservables,
    private settingsService: SettingsService,
    private helpService: HelperService
  ) {}

  ngOnInit() {
    this.startDate = new Date();
    this.getAppSettingInformation();
  }

  getAppSettingInformation() {
    this.appSettingInfo = [];
    // this.adminService.getAppSettingInformation().subscribe(
    //   info => {
    //     if (info) {
    //       this.appSettingInfo = Object.entries(info);
    //     }
    //   });
  }

  getTextResource() {
    this.adminService.getTextResourceForName(this.textResourceKey).subscribe((result) => {
      if (result.value) {
        this.textResourceValue = result.value;
      } else {
        this.textResourceValue = 'Unable to find Text Resource';
      }
    });
  }
}
